module.exports = __webpack_public_path__ + "static/step-4-8bfe2803ea4092bc227928d95da6e4e8.svg";